import { CDSFooter } from "@ciscodesignsystems/cds-react-footer";

const PRIVACY_POLICY_URL = "https://www.cisco.com/c/en/us/about/legal/privacy-full.html";
const TERMS_OF_SERVICE_URL = "https://www.cisco.com/c/en/us/about/legal/terms-conditions.html";
export const FILL_FORM_DATA_EVENT = "uag:fill-form-data";

const handleFooterBrandClick = () => {
  window.dispatchEvent(new Event(FILL_FORM_DATA_EVENT));
};

const Footer = () => (
  <CDSFooter
    className="uag-footer"
    brandName={
      <button className="uag-footer-brand-trigger" onClick={handleFooterBrandClick} type="button">
        Cisco Systems, Inc.
      </button>
    }
    rightSlot={
      <>
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        <a className="uag-footer-anchor" href={TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">
          Terms of Service
        </a>
      </>
    }
  />
);

export default Footer;
